import {action, computed, observable} from 'mobx';
import API from '../../apis';
import {message} from 'antd';
import window from '../../util';
import { WeaTableNew} from 'comsMobx';
//import {WeaLocaleProvider} from 'ecCom';
import PaginationStore from '../../util/pagination';

const { TableStore } = WeaTableNew;

//const getLabel = WeaLocaleProvider.getLabel;

export class amkjzgStore {
    constructor() {
        
    }

    @observable exp_url = ""; // 链接地址
    @observable hcstatusoptions = [];
    @observable hctypeoptions = [];
    @observable flstoptions = [];

    sessionKey = '';
    @observable params = {} as any;
    @observable loading = false; // 加载中状态
    @observable newTable = new TableStore();
   
    @observable iconInfo = {
        icon: "icon-coms-ModelingEngine",
        iconColor: "#fff",
        iconBg: "#96358a"
    }

   
    @observable countData: any = {}; //查询统计数据
    @observable isCharts: boolean = false; //查询统计数据

    
    @observable starttime: any=new Date().getTime();
    @observable showProgerss:  boolean = false;//是否显示导出进度
    @observable isCancel:  boolean = false;//是否显示导出进度
    @observable isClose:  boolean = false;//是否关闭进度条
    @observable progress:  any = {};//是否显示导出进度
    @observable exportkey:  string = "";//导出唯一key
    originalTableWidth;//列宽百分比

    clearTable = () => {
        this.newTable = new TableStore();
    }
    @observable editPagination = new PaginationStore();

    @computed
    get register_table() {
        return {
            reLoad: () => {
                this.reload();
                if (this.params.isRefreshTree == '1') {
                    (window as any).refreshTree(this.params.customTreeDataId);
                }
            }
        };
    }

    @computed get tableDatas() {
        return this.newTable.datas;
    }

    @action
    clear = () => {
        this.newTable = new TableStore();
        this.loading = false;       
        this.sessionKey = '';       
    }
    @action
    update = (param: any) => {
        for (let key in param) {
            this[key] = param[key]
        }
    }

    @action
    getSlectOption = (params: any) => {
        this.loading = true;
        //处理选择框的key
        API.amkjzgSlectOption({ ...params, ...this.params}).then(action(({ error, status,hcstatus, hctype, flst,exp_url }) => {
            if (status == '1') {
                this.hcstatusoptions = hcstatus.options;
                this.hctypeoptions = hctype.options;
                this.flstoptions = flst.options;  
                this.exp_url = exp_url;              
            } else {
                message.error(error)
                throw error;
            }            
        }));
    }

   
    @action
    dataKey = (params: any) => {
        this.loading = true;
        //处理选择框的key
        API.amkjzgdataKey({ ...params, ...this.params}).then(action(({ error, status, datas, countData, originalTableWidth  }) => {
            if (status == '1') {
                this.sessionKey = datas;
                this.countData = countData;
                this.clearTable();
                this.newTable.getDatas(datas);
                this.originalTableWidth =originalTableWidth;            
            } else {
                message.error(error)
                throw error;
            }            
        }));
    }
   
    @action
    refresh = () => {
        this.loading = true;        
        this.dataKey({
            ...this.params
        });
    }

    @action
    reload = () => {
        this.newTable.getDatas('', this.newTable.current, this.newTable.pageSize);
    }

    @action
    doExcelExpost = (startdate,hcstatus,hctype,branch,department,bgdd) => {
        //message.info(getLabel('508305','正在导出文件'));
        // API.doExcelExpost(params).then(action(({ error, status,key }) => {
        //     if(status=='1'){//成功
        //         this.exportkey=key;
        //         this.getExcelExpProgress();
        //     }else if(status=='2'){
        //         message.info(error);
        //     }else{
        //         message.error(error);
        //     }
        // }));
        window.location.href="/weaver/weaver.formmode.amkjgs.ExcelOutFromReport?current"+this.newTable.current+"&pageSize="+this.newTable.pageSize+"&startdate="+startdate+"&hcstatus="+hcstatus+"&hctype="+hctype+"&branch="+branch+"&department="+department+"&bgdd="+bgdd;
    }
}

export default new amkjzgStore();



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/amkjzg/index.tsx